export default "__VITE_ASSET__afed0b92__"